var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-2 col-sm-2 col-md-2 col-lg-2 mt-2"},[_c('label',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }